/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ProfileData/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Age from './Age/index'
import AgeGenderSeparator from './AgeGenderSeparator/index'
import DateOfBirth from './DateOfBirth/index'
import Gender from './Gender/index'
import GenderBirthSeparator from './GenderBirthSeparator/index'
import Name from './Name/index'
import React from 'react'
import SuspenseBoundary from 'DesignSystem/SuspenseBoundary/index'
import TysiaIconPersonFilled from 'DesignSystem/Svgs/TysiaIconPersonFilled/index'
import styles from './view.module.css'
let Locations = React.lazy(() => import('./Locations/index'))



/** @type {import('Simple/types.js').View} */
export default function ProfileData({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Relations/AddRelation/Search/Content/Profiles/Content/Profile/ProfileData"
  
}) {
let personIsPatientValueData = fromData.useDataValue({ viewPath,
context: 'person',
path: 'is_patient',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<div
  data-testid="ProfileData.Vertical"
  data-view-path={viewPath}
 style={{'--ml-1-2bfKmT': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<Name
  viewPath={`${viewPath}/Name`}
/>
<div
  data-testid="ProfileData.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaIconPersonFilled
  viewPath={`${viewPath}/TysiaIconPersonFilled`}
 width={dtSpaceS}
 height={dtSpaceS}
 fill={dtColorsNeutral600}
/>
<Age
  viewPath={`${viewPath}/Age`}
/>
<AgeGenderSeparator
  viewPath={`${viewPath}/AgeGenderSeparator`}
/>
<Gender
  viewPath={`${viewPath}/Gender`}
/>
<GenderBirthSeparator
  viewPath={`${viewPath}/GenderBirthSeparator`}
/>
<DateOfBirth
  viewPath={`${viewPath}/DateOfBirth`}
/>
</div>
<SuspenseBoundary
  viewPath={`${viewPath}/SuspenseBoundary`}
>
{childProps => (
<Locations
{...childProps}
  viewPath={`${viewPath}/Locations`}
/>
)}
</SuspenseBoundary>
</div>
{children}
</React.Fragment>)
}